import { HFlow, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader } from 'bold-ui'
import {
  useVisualizarNovidadesQuery,
  useVisualizouNovidadesMutation,
  VisualizarNovidadesDocument,
} from 'graphql/hooks.generated'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import moment from 'moment'
import { useEffect, useState } from 'react'

import { NewsModalBody } from './NewsModalBody'

export const NewsModal = () => {
  const { data } = useVisualizarNovidadesQuery({ fetchPolicy: 'cache-first' })
  const [isOpen, setIsOpen] = useState(true)
  const visualizarDepois = localStorage.getItem('NEWS')
  const visualizarNovidades = data?.sessao?.profissional?.usuario?.visualizouNovidades

  const [visualizouNews] = useVisualizouNovidadesMutation({
    refetchQueries: [{ query: VisualizarNovidadesDocument }],
  })

  const { analytics } = useAnalytics()
  const [timeStart, setTimeStart] = useState(undefined)

  useEffect(() => {
    setTimeStart(moment.now())
  }, [setTimeStart])

  const handleModalClose = (visitouNews: boolean) => {
    setIsOpen(false)
    const timeStop = moment.now()
    const duration = timeStop - timeStart
    if (visitouNews) {
      analytics.logEvent('news_modal_visit')
    } else {
      analytics.logEvent('news_modal_close', getAnalyticsEventNewsProps(duration))
    }
    return visualizouNews()
  }

  const getAnalyticsEventNewsProps = (duration: number) => {
    let speed = 'slow'
    if (duration < 3000) {
      speed = 'fast'
    } else if (duration < 6000) {
      speed = 'medium'
    }
    return {
      speed: speed,
      duration: duration,
    }
  }

  const handleRememberLater = () => {
    setIsOpen(false)
    analytics.logEvent('news_modal_remind_later')
    localStorage.setItem('NEWS', '1')
  }

  return (
    <>
      {visualizarNovidades === false && visualizarDepois !== '1' && (
        <Modal
          onClose={() => handleModalClose(false)}
          open={isOpen}
          size='auto'
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}
        >
          <ModalHeader title='Novidades da versão' />
          <ModalBody style={{ width: '47rem' }}>
            <NewsModalBody handleModalClose={() => handleModalClose(true)} />
          </ModalBody>
          <ModalFooter>
            <HFlow justifyContent='flex-end'>
              <ModalFooterButton kind='primary' onClick={handleRememberLater}>
                Lembrar depois
              </ModalFooterButton>
            </HFlow>
          </ModalFooter>
        </Modal>
      )}
    </>
  )
}
